import { gql } from '@apollo/client/core';

const AUTH_LOCATION_FRAGMENT = gql`
  fragment AuthLocationFragment on Location {
    id
    location_id
    organization_id
    alias
    title
    short_name
    color
    enabled
    photo
    icon
    city
    address
    full_address
    phone
    latitude
    longitude
    coordinate
    timezone
    opened_from
    closed_from
  }
`;

const AUTH_ORGANIZATION_FRAGMENT = gql`
  fragment AuthOrganizationFragment on Organization {
    id
    alias
    title
    sphere_id
    resource_term
    domain
    enabled_modules
    known_add_ons
    timezone
    currency
    country_code
    has_locations
    created_at
    updated_at
    locations {
      ...AuthLocationFragment
    }
  }
  ${AUTH_LOCATION_FRAGMENT}
`;

export const AUTH_CONTEXT = gql`
  query AuthContext {
    authContext {
      user {
        id
        phone
        first_name
        last_name
        patronymic_name
        telegram_id
        is_super_user
      }
      employee {
        id
        title
        first_name
        last_name
        patronymic_name
        phone
        employee_id
        role_id
        status
        fired_at
        fired_reason
        created_at
        last_activity_at
        has_all_locations_access
        location_ids
        is_owner
      }
      organization {
        ...AuthOrganizationFragment
      }
      location {
        ...AuthLocationFragment
      }
      permissions
      available_organizations {
        ...AuthOrganizationFragment
      }
    }
    impersonationState {
      active
      session_id
      started_at
      impersonator {
        id
        phone
        first_name
        last_name
        patronymic_name
        is_super_user
      }
      target_user {
        id
        phone
        first_name
        last_name
        patronymic_name
        is_super_user
      }
      organization {
        id
        alias
        title
      }
    }
  }
  ${AUTH_ORGANIZATION_FRAGMENT}
`;
